import { c as _c } from "react/compiler-runtime";
import type { LinkTilesProps } from '../types';
import LinkBlock from './LinkBlock';
import './Tile4Links.scss';
export default function Tile4Links(t0) {
  const $ = _c(4);
  const {
    tiles
  } = t0;
  let t1;
  if ($[0] !== tiles) {
    t1 = tiles.map(_temp);
    $[0] = tiles;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="tile4-links">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(linkBlock) {
  return <LinkBlock {...linkBlock} key={linkBlock.sysId} />;
}